import { CommonApiResultError } from "shared/networking/common_api_result";

export const VERSION_CONFLICT_ERROR_CODE = 114;

export function isVersionConflict(error: unknown): boolean {
  return (
    error instanceof CommonApiResultError &&
    error.errorCode === VERSION_CONFLICT_ERROR_CODE
  );
}
